module.exports = __webpack_public_path__ + "static/media/qyj_hg_lb.45b6ec3b.png";